//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/javascript/util'
import goBack from '@/components/public-components/goBack/index.vue'
import Footer from "@/components/lyx-components/lyx-footer/index"

export default {
    components: {
        goBack,
        Footer
    },
    data() {
        return {
            minHeight: 0,
            newsData: {},
            titleImage: '',
            collectParams: {},
            history: '',
            isLogin: false,
            keyData: new Date().getTime(),
            sharePage: {},
            position:{
                top: '0rem',
                right: '0rem',
            }
        }
    },
    methods: {
        // 详情数据
        getNewsDetails() {
            this.$http.get(`api/wtcp-cms/public/news/${this.$route.query.id}`).then(res => {
                this.newsData = res.data.data.news
                this.titleImage = ''
                for (let material of res.data.data.newsMaterials) {
                    if (material.fileType == 'image') {
                        this.titleImage = material.fileUrl
                        break
                    }
                }
                if(this.titleImage){
                    this.position.top = '.2rem'
                    this.position.right = '.2rem'
                }else{
                    this.position.top = '.4rem'
                    this.position.right = '1rem'
                }
            }).then(() => {
                document.title = this.newsData.title

                this.collectParams = {
                    catalog: this.XQSC_TYPE_CODE.XW, //类别
                    picUrl: this.titleImage, //图片URL
                    principalId: this.newsData.id, //被收藏对象id
                    serviceType: this.SERVICE_TYPE.XW, //浏览信息所属的服务类型
                    summary: this.newsData.description ? this.newsData.description : '', //简介
                    title: this.newsData.title, //浏览信息页面的标题
                    articleSite: window.location.pathname + window.location.hash, //浏览页面信息的地址
                }

                this.history = {
                    catalog: this.XQSC_TYPE_CODE.XW,
                    serviceType: this.SERVICE_TYPE.XW,
                    summary: '',
                    title: this.newsData.title,
                    url: window.location.pathname + window.location.hash,
                    picUrl: this.titleImage
                }

                this.sharePage = {
                    url: window.location.href,
                    title: this.newsData.title,
                    image: this.titleImage ? this.PIC_BASE_URL + this.titleImage : this.SHARE_IMG,
                    desc: this.newsData.description ? this.newsData.description : this.SHARE_TEXT
                }

                
            }).then(() => {
                this.keyData = new Date().getTime()
            });
        },
        
    },
    
    mounted() {
        this.minHeight = document.documentElement.clientHeight
        this.getNewsDetails()
    }
};
